import React, { FC } from "react";
import { makeStyles } from "tss-react/mui";
import {
  AutocompleteOption,
  MiAutocomplete,
  MiSkeleton,
  SKELETON_VARIANTS,
} from "@miplatform/components";
import { Box, Typography } from "@mui/material";

export const FilterSidebarDynamicDataFilter: FC<
  FilterSidebarDynamicDataFilterProps
> = ({ options, label, value, fieldKey, onChange, renderOption, loading }) => {
  const { classes } = useStyles();
  return (
    <Box>
      <Typography className={classes.label}>{label}</Typography>
      {loading ? (
        <MiSkeleton
          variant={SKELETON_VARIANTS.RECTANGULAR}
          height={40}
          className={classes.loadingInput}
        />
      ) : (
        <MiAutocomplete
          name={fieldKey}
          getOptionLabel={(option: AutocompleteOption) => option.label}
          options={options}
          value={options.find((opt) => opt.value === value) || null}
          required
          onChange={(_, newValue) =>
            onChange(fieldKey, newValue ? newValue.value : "")
          }
          className={classes.filterInput}
          renderOption={renderOption}
        />
      )}
    </Box>
  );
};

interface FilterSidebarDynamicDataFilterProps {
  label: string;
  options: { label: string; value: string | number | undefined }[];
  value: string | number | undefined;
  fieldKey: string;
  onChange: (fieldKey: string, value: string | number | undefined) => void;
  renderOption?: (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: { label: string; value: string | number | undefined }
  ) => React.ReactNode;
  loading?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  label: {
    fontSize: theme.fontSize.small,
    fontWeight: 600,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterInput: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
  },
  loadingInput: {
    borderRadius: theme.spacing(1),
  },
}));
